import { render, staticRenderFns } from "./CodeList.vue?vue&type=template&id=128f355a&"
import script from "./CodeList.vue?vue&type=script&lang=ts&"
export * from "./CodeList.vue?vue&type=script&lang=ts&"
import style0 from "./CodeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports